<div class="row">
    <div class="col-md-7 grid-margin stretch-card">
        <div class="card">
            <div >
                <div id="map"></div>
            </div>
        </div>
    </div>
    <div class="col-md-5 grid-margin stretch-card">
        <div class="card">
            <div class="text-center">
                <div id="section_2" *ngIf="section == 1">

                    <h4 class="text-center">
                        กองทุนจัดรูปที่ดินเพื่อพัฒนาพื้นที่ <br>
                        ได้สนับสนุนเงินแก่โครงการจัดรูปที่ดิน <br>
                        เพื่อพัฒนาพื้นที่ <br>
                        ตั้งแต่ปีงบประมาณ พ.ศ. {{year_start}} – {{year_end}} <br>
                        ทั้งหมด {{count_prov}} จังหวัด {{sum_project}} สัญญา ดังนี้
                    </h4>
                    <hr>
                    <div class="row">
                        <div class="col-md-6">
                            <button class="btn btn-block btn-block btn-info btn-list-menu"
                                (click)="select_section(2)">
                                <i class="mdi mdi-account-switch btn-icon-prepend mdi-36px"></i><br>
                                <span class="d-inline-block text-left" style="margin-top: 10px;">
                                    <h4 class=" d-block text-center">
                                        อุดหนุน <br> <span class="font-weight-light" style="font-size: smaller;">{{list_province.length}} สัญญา </span>
                                        <br> <span class="font-weight-light " style="font-size: smaller; margin-top: 10px;">{{sum_budget | number}}</span>
                                    </h4>
                                </span>
                            </button>
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-block btn-block btn-danger btn-list-menu"
                                (click)="select_section(3)">
                                <i class="mdi mdi-account-convert btn-icon-prepend mdi-36px"></i> <br>
                                <span class="d-inline-block text-left" style="margin-top: 10px;">
                                    <h4 class=" d-block text-center">
                                        กู้ยืม <br> <span class="font-weight-light" style="font-size: smaller;">{{list_province_2.length}} สัญญา </span>
                                        <br> <span class="font-weight-light " style="font-size: smaller; margin-top: 10px;">{{sum_budget_2 | number}}</span>
                                    </h4>
                                </span>
                            </button>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-md-6">
                            <button class="btn btn-block btn-block btn-success btn-list-menu"
                            (click)="select_section(4)">
                            <i class="mdi mdi-bank btn-icon-prepend mdi-36px"></i><br>
                            <span class="d-inline-block text-left" style="margin-top: 10px;">
                                <h4 class=" d-block text-center">
                                    สนับสนุน <br> <span class="font-weight-light" style="font-size: smaller;">{{list_province_3.length}} สัญญา </span>
                                    <br> <span class="font-weight-light " style="font-size: smaller; margin-top: 10px;">{{sum_budget_3 | number}}</span>
                                </h4>
                            </span>
                        </button>
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-block btn-block btn-warning btn-list-menu"
                                (click)="select_section(5)">
                                <i class="mdi mdi-account-star btn-icon-prepend mdi-36px"></i> <br>
                                <span class="d-inline-block text-left" style="margin-top: 10px;">
                                    <h4 class=" d-block text-center">
                                        ทดรองจ่าย <br> <span class="font-weight-light" style="font-size: smaller;">{{list_province_4.length}}  สัญญา </span>
                                        <br> <span class="font-weight-light " style="font-size: smaller; margin-top: 10px;">{{sum_budget_4 | number}}</span>
                                    </h4>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>

                <div id="section_2" *ngIf="section == 2">
                    <button type="button" class="btn btn-outline-danger btn-icon-text close"
                        (click)="select_section(1)">
                        <i class="mdi mdi-backspace btn-icon-prepend"></i> กลับ </button>
                    <h4 class="text-left">เงินอุดหนุน</h4>
                    <hr>
                    <div class="table-data">
                        <table class="table table-hover" style="cursor: context-menu;">
                            <thead>
                                <tr>
                                    <th scope="col" style="font-weight: 500;">#</th>
                                    <th scope="col" style="font-weight: 500;">จังหวัด</th>
                                    <th scope="col" style="font-weight: 500;">ยอดเงิน</th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let item of list_province; let i=index">
                                <tr>
                                    <td scope="row">{{i+1}}</td>
                                    <td>{{item.name}}</td>
                                    <td>{{item.value | number}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <br>

                    </div>
                </div>

                <div id="section_2" *ngIf="section == 3">
                    <button type="button" class="btn btn-outline-danger btn-icon-text close"
                        (click)="select_section(1)">
                        <i class="mdi mdi-backspace btn-icon-prepend"></i> กลับ </button>
                    <h4 class="text-left">เงินกู้ยืม</h4>
                    <hr>
                    <div class="table-data">
                        <table class="table table-hover" style="cursor: context-menu;">
                            <thead>
                                <tr>
                                    <th scope="col" style="font-weight: 500;">#</th>
                                    <th scope="col" style="font-weight: 500;">จังหวัด</th>
                                    <th scope="col" style="font-weight: 500;">ยอดเงิน</th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let item of list_province_2; let i=index">


                                <tr>
                                    <th scope="row">{{i+1}}</th>
                                    <td>{{item.name}}</td>
                                    <td>{{item.value | number}}</td>
                                </tr>


                            </tbody>
                        </table>
                    </div>
                </div>
                <div id="section_2" *ngIf="section == 4">
                    <button type="button" class="btn btn-outline-danger btn-icon-text close"
                        (click)="select_section(1)">
                        <i class="mdi mdi-backspace btn-icon-prepend"></i> กลับ </button>
                    <h4 class="text-left">เงินสนับสนุน</h4>
                    <hr>
                    <div class="table-data">
                        <table class="table table-hover" style="cursor: context-menu;">
                            <thead>
                                <tr>
                                    <th scope="col" style="font-weight: 500;">#</th>
                                    <th scope="col" style="font-weight: 500;">จังหวัด</th>
                                    <th scope="col" style="font-weight: 500;">ยอดเงิน</th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let item of list_province_3; let i=index">


                                <tr>
                                    <th scope="row">{{i+1}}</th>
                                    <td>{{item.name}}</td>
                                    <td>{{item.value | number}}</td>
                                </tr>


                            </tbody>
                        </table>
                    </div>
                </div>
                <div id="section_2" *ngIf="section == 5">
                    <button type="button" class="btn btn-outline-danger btn-icon-text close"
                        (click)="select_section(1)">
                        <i class="mdi mdi-backspace btn-icon-prepend"></i> กลับ </button>
                    <h4 class="text-left">เงินทดรองจ่าย</h4>
                    <hr>
                    <div class="table-data">
                        <table class="table table-hover" style="cursor: context-menu;">
                            <thead>
                                <tr>
                                    <th scope="col" style="font-weight: 500;">#</th>
                                    <th scope="col" style="font-weight: 500;">จังหวัด</th>
                                    <th scope="col" style="font-weight: 500;">ยอดเงิน</th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let item of list_province_4; let i=index">


                                <tr>
                                    <th scope="row">{{i+1}}</th>
                                    <td>{{item.name}}</td>
                                    <td>{{item.value | number}}</td>
                                </tr>


                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>


    </div>
</div>